import {format, lastDayOfMonth} from 'date-fns';

export const getCurrentMonthStartEndDate = () => {
  const today = new Date();
  const firstDateOfMonth = format(today, 'yyyy-MM-01');
  const lastDateOfMonth = format(lastDayOfMonth(today), 'yyyy-MM-dd');

  return [new Date(firstDateOfMonth), new Date(lastDateOfMonth)];
};
